<template>
  <check-box v-if="valueName == 'check_box'" />
  <check-box-outline-blank v-else-if="valueName == 'check_box_outline_blank'" />
  <indeterminate-check-box v-else-if="valueName == 'indeterminate_check_box'" />
  <radio-button-checked v-else-if="valueName == 'radio_button_checked'" />
  <radio-button-unchecked v-else-if="valueName == 'radio_button_unchecked'" />
  <star v-else-if="valueName == 'star'" />
  <star-border v-else-if="valueName == 'star_border'" />
  <star-half v-else-if="valueName == 'star_half'" />
  <star-outline v-else-if="valueName == 'star_outline'" />
  <toggle-off v-else-if="valueName == 'toggle_off'" />
  <toggle-on v-else-if="valueName == 'toggle_on'" />
</template>

<script>
import CheckBox from "@/components/Icons/Toggle/CheckBox";
import CheckBoxOutlineBlank from "@/components/Icons/Toggle/CheckBoxOutlineBlank";
import IndeterminateCheckBox from "@/components/Icons/Toggle/IndeterminateCheckBox";
import RadioButtonChecked from "@/components/Icons/Toggle/RadioButtonChecked";
import RadioButtonUnchecked from "@/components/Icons/Toggle/RadioButtonUnchecked";
import Star from "@/components/Icons/Toggle/Star";
import StarBorder from "@/components/Icons/Toggle/StarBorder";
import StarHalf from "@/components/Icons/Toggle/StarHalf";
import StarOutline from "@/components/Icons/Toggle/StarOutline";
import ToggleOff from "@/components/Icons/Toggle/ToggleOff";
import ToggleOn from "@/components/Icons/Toggle/ToggleOn";

export default {
  components: {
    CheckBox,
    CheckBoxOutlineBlank,
    IndeterminateCheckBox,
    RadioButtonChecked,
    RadioButtonUnchecked,
    Star,
    StarBorder,
    StarHalf,
    StarOutline,
    ToggleOff,
    ToggleOn,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
